<img [src]="value" class="qr-code img-thumbnail img-responsive" />
